export default __webpack_public_path__ + "static/media/Ptal Logo-1.ad2cadb7.png";